import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import EditCondition from './EditCondition.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ouroboros'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'settings_ouroboros_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'settings_ouroboros_list',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: ':inboxId/edit',
          name: 'settings_ouroboros_edit',
          component: EditCondition,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};